import CryptoJS from 'crypto-js'
import { Log, UserManager, WebStorageStateStore } from 'oidc-client'
import Vue from 'vue'

import { CRYPTO_KEY } from '@/fixtures/Hash'

const EncryptedLocalStorage = {
  setItem(key, value) {
    const encrypted = CryptoJS.AES.encrypt(value, CRYPTO_KEY).toString()
    localStorage.setItem(key, encrypted)
  },
  getItem(key) {
    const encrypted = localStorage.getItem(key)
    if (!encrypted) return null
    try {
      return CryptoJS.AES.decrypt(encrypted, CRYPTO_KEY).toString(CryptoJS.enc.Utf8)
    } catch (err) {
      return null;
    }
  },
  removeItem(key) {
    localStorage.removeItem(key)
  },
  getAllKeys() {
    return Object.keys(localStorage)
  }
}

export const EventBus = new Vue()

const OidcPlugin = {
  install(Vue, options) {
    const oidcDefaultSettings = {
      authority: `https://login.microsoftonline.com/${process.env.VUE_APP_TENANT_ID}/v2.0`,
      client_id: process.env.VUE_APP_CLIENT_ID,
      redirect_uri: process.env.VUE_APP_REDIRECT_URI,
      response_type: 'id_token token',
      silent_redirect_uri: process.env.VUE_APP_REDIRECT_URI,
      loadUserInfo: false,
      automaticSilentRenew: true,
      silentRequestTimeout: 10000,
      monitorSession: true,
      scope: `openid profile offline_access api://itportfolio-itmapi/Read.Write.ITportfolio.Auth`,
      post_logout_redirect_uri: `${process.env.VUE_APP_REDIRECT_URI}?post_logout_redirect=true`,
      userStore: new WebStorageStateStore({
        store: EncryptedLocalStorage
      })
    }

    const oidcSettings = {
      ...oidcDefaultSettings,
      ...options
    }

    const userManager = new UserManager(oidcSettings)

    Vue.prototype.$oidc = {
      userManager,
      signin: () => userManager.signinRedirect(),
      signinCallback: () => userManager.signinRedirectCallback(),
      signout: () => userManager.signoutRedirect(),
      renewToken: () => userManager.signinSilent(),
      getUser: () => userManager.getUser(),
      signinSilent: () => userManager.signinSilent(),
      signinSilentCallback: () => userManager.signinSilentCallback()
    }

    Vue.$oidc = Vue.prototype.$oidc
  }
}

Vue.use(OidcPlugin)

export default OidcPlugin